export default "__VITE_ASSET__c6e7924c__"